import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Hook personnalisé pour gérer la redirection après authentification
 * Utilise l'URL actuelle comme destination de redirection
 */
export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Redirige vers la page de login en sauvegardant l'URL actuelle
   * pour redirection après authentification
   */
  const redirectToLogin = () => {
    const currentPath = location.pathname + location.search;
    navigate('/login', {
      state: { from: currentPath },
      replace: true,
    });
  };

  /**
   * Redirige vers une URL spécifique en sauvegardant l'URL actuelle
   * pour redirection après authentification
   */
  const redirectToLoginWithTarget = (targetUrl: string) => {
    // Normaliser l'URL cible
    let normalizedTarget = targetUrl;

    // Si c'est une URL complète, extraire seulement le chemin
    if (targetUrl.startsWith('http')) {
      try {
        const url = new URL(targetUrl);
        normalizedTarget = url.pathname + url.search;
      } catch (error) {
        console.error('Invalid URL:', targetUrl);
        normalizedTarget = '/';
      }
    }

    // S'assurer que le chemin commence par /
    if (!normalizedTarget.startsWith('/')) {
      normalizedTarget = '/' + normalizedTarget;
    }

    navigate('/login', {
      state: { from: normalizedTarget },
      replace: true,
    });
  };

  return {
    redirectToLogin,
    redirectToLoginWithTarget,
  };
};
